import React from 'react';
import { BASE_URL } from '../Base_url/Base_Url';
import './bannerdeta.css';
function Banner_deatil({ Banner, Serviceloading, name, slug }) {
    // Fallback image agar API image nahi aayi
    const bannerImage = Banner
        ? `${BASE_URL}/${Banner}`
        : '/Imges/raj.png';

    return (
        <div
            className="banner-container"
            style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${bannerImage})`,
            }}
        >
            {Serviceloading ? (
                <div className="d-flex justify-content-center align-items-center vh-50 w-100">
                    {/* <Loader show={Serviceloading} /> */}
                </div>
            ) : (
                <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                    <h4 className="text-white display-4 mb-4 text-uppercase">{name}</h4>
                    <ol className="breadcrumb d-flex justify-content-center mb-0">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item"><a href="#">Pages</a></li>
                        <li className="breadcrumb-item active text-primary">{slug || name}</li>
                    </ol>
                </div>
            )}
        </div>
    );
}

export default Banner_deatil;
